import { showFile, downLoadFile,downLoadFilesZip } from '@/api/sys/oss'
import Vue from 'vue'
import qs from 'qs'
import { ACCESS_TOKEN } from '@/store/mutation-types'
const showFileUrl = '/ws/oss/showFile';
const downloadToFastdfsUrl = '/ws/oss/downloadToFastdfs';
const showOutFileUrl = '/out/oss/showFile';
const showHeadImgUrl = '/ws/oss/showHeadImg';
const showPublicFileUrl = '/wxyimu/file/showImage?id=';
/**
 * 得到文件下载路径
 * @param id
 * @returns {Promise<*>}
 */

function getFileUrl(id) {
  if(id == '0'){
    return null;
  }
  const token = Vue.ls.get(ACCESS_TOKEN)
  //测试使用
  // if(process.env.NODE_ENV == 'development'){
  //   id = "ab95c185665ea6c1"
  // }
  let url = process.env.VUE_APP_SERVER_URL+showFileUrl+`?id=${id}&token=${token}`;
  // console.log(url)
  return url;
}

function getFastFileUrl(id) {
  if(id == '0'){
    return null;
  }
  const token = Vue.ls.get(ACCESS_TOKEN)
  //测试使用
  // if(process.env.NODE_ENV == 'development'){
  //   id = "ab95c185665ea6c1"
  // }
  let url = process.env.VUE_APP_SERVER_URL+downloadToFastdfsUrl+`?id=${id}&token=${token}`;
  // console.log(url)
  return url;
}

function getOutFileUrl(id) {
  if(id == '0'){
    return null;
  }
  const token = Vue.ls.get(ACCESS_TOKEN)
  //测试使用
  // if(process.env.NODE_ENV == 'development'){
  //   id = "ab95c185665ea6c1"
  // }
  let url = process.env.VUE_APP_SERVER_URL+showOutFileUrl+`?id=${id}&token=Ym1zbmFidjg3Z2Y6OGMyOGIwZjEzODc5NDA1NjliOGU4ZDA5ZDFlZTcxYjU=`;
  // console.log(url)
  return url;
}


function getHeadImgUrl(id) {
  if(id == '0'){
    return null;
  }
  const token = Vue.ls.get(ACCESS_TOKEN)
  //测试使用
  // if(process.env.NODE_ENV == 'development'){
  //   id = "ab95c185665ea6c1"
  // }
  let url = process.env.VUE_APP_SERVER_URL+showHeadImgUrl+`?userId=${id}&token=${token}`;
  // console.log(url)
  return url;
}


/**
 * 新窗口打开图片或者是能打开的文件
 * @param id
 * @returns {Promise<void>}
 */
async function showImage(id) {
  const token = Vue.ls.get(ACCESS_TOKEN)
  //测试使用
  // if(process.env.NODE_ENV == 'development'){
  //   id = "ab95c185665ea6c1"
  // }
  let url = process.env.VUE_APP_SERVER_URL+showFileUrl+`?id=${id}&token=${token}`;
    window.open(url,"_blank")

}

/**
 * 下载文件
 * @param id
 * @param fileName
 */
function dowLoadFile(id, fileName,_this) {
    // window.open(getFileUrl(id),"_blank") 直接访问阿里云地址 然后能打开就打开不能打开就直接下载.
  _this.$loading.show({
    tip:'正在下载，请稍等。'
  })
  downLoadFile(id).then(res=>{
    console.log("下载文件:"+res)
    _this.$loading.hide()
    if (!res.code) {
      console.log(res)
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(res)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)// 释放URL 对象
        document.body.removeChild(elink)
      } else { // IE10+下载
        navigator.msSaveBlob(res, fileName)
      }
    } else {
      _this.$message.error(res.message)
    }
  }).finally(()=>{
    _this.$loading.hide()
  })

}
/**
 * 下载文件并打zip
 * @param id
 * @param fileName
 */
function dowLoadFilesZip(idList, fileName,_this) {
    // window.open(getFileUrl(id),"_blank") 直接访问阿里云地址 然后能打开就打开不能打开就直接下载.
  _this.$loading.show({
    tip:'正在下载，请稍等。'
  })
  downLoadFilesZip(idList).then(res=>{
    console.log("下载文件")
    _this.$loading.hide()
    if (!res.code) {
      console.log(res)
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(res)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)// 释放URL 对象
        document.body.removeChild(elink)
      } else { // IE10+下载
        navigator.msSaveBlob(res, fileName)
      }
      _this.$message.success('下载成功')
    } else {
      _this.$message.error(res.message)
    }
  }).finally(()=>{
    _this.$loading.hide()
  })

}

/**
 * 打开新窗口预览文件
 * @param id
 */
function previewFile(id){
  window.open(getFileUrl(id),"_blank")
}

/**
 * 打开新窗口预览文件
 * @param id
 */
function downloadFile(id){
  window.location.href=getFileUrl(id)
}

/**
 * 判断文件格式是否支持预览
 * @param fileName
 */
function matchPreviewType(fileName){
  let suffix = '';
  let isMatch = false;
  let matchTypeList = ['png','jpg','jpeg','pdf']
  let fileNameArr = fileName.split('.');
  if(fileNameArr.length > 0){
    suffix = fileNameArr[fileNameArr.length - 1].toLowerCase();
  }else{
    suffix = '';
  }
  if(!suffix){
    isMatch = false;
    return isMatch;
  }
  matchTypeList.forEach((item)=>{
    if(item == suffix){
      isMatch = true;
    }
  })
  return isMatch;
}

function exportFile(url,params){
  const token = Vue.ls.get(ACCESS_TOKEN)
  if(params){
    params.token = token
  }else{
    params = {token:token}
  }
  let paramsStr = qs.stringify(params, { indices: false })
  window.location.href = process.env.VUE_APP_SERVER_URL+url+"?"+paramsStr;
}


function showPdfFile(url,params){
  const token = Vue.ls.get(ACCESS_TOKEN)
  if(params){
    params.token = token
  }else{
    params = {token:token}
  }
  let paramsStr = qs.stringify(params, { indices: false })
  window.open(process.env.VUE_APP_SERVER_URL+url+"?"+paramsStr);
}


function getPublicFileUrl(id) {
  if(id == '0'){
    return null;
  }
  //测试使用
  // if(process.env.NODE_ENV == 'development'){
  //   id = "ab95c185665ea6c1"
  // }
  let url = process.env.VUE_APP_SERVER_URL+showPublicFileUrl+`${id}`;
  // console.log(url)
  return url;
}

/**
 * 去掉对象里面的 ~ 符号
 * @param obj
 */
function replaceString(obj){
  for(let key in obj){
    if(obj[key] == "~"){
      obj[key] = undefined;
    }
    if(obj[key] instanceof  Object){
      replaceString(obj[key])
    }
  }
}



export default {
  getFastFileUrl,
  getPublicFileUrl,
  getFileUrl,
  downloadFile,
  dowLoadFilesZip,
  getOutFileUrl,
  showImage,
  dowLoadFile,
  showPdfFile,
  replaceString,
  exportFile,
  getHeadImgUrl,
  previewFile,
  matchPreviewType
}